/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiGetOrCreateUserRequestFromJSON(json) {
    return StreemApiGetOrCreateUserRequestFromJSONTyped(json, false);
}
export function StreemApiGetOrCreateUserRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'markAsUserType': !exists(json, 'mark_as_user_type') ? undefined : json['mark_as_user_type'],
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
    };
}
export function StreemApiGetOrCreateUserRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mark_as_user_type': value.markAsUserType,
        'groups': value.groups,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiGetOrCreateUserRequestMarkAsUserType;
(function (StreemApiGetOrCreateUserRequestMarkAsUserType) {
    StreemApiGetOrCreateUserRequestMarkAsUserType["INVITED"] = "USER_TYPE_INVITED";
    StreemApiGetOrCreateUserRequestMarkAsUserType["LOGIN"] = "USER_TYPE_LOGIN";
    StreemApiGetOrCreateUserRequestMarkAsUserType["SDK"] = "USER_TYPE_SDK";
    StreemApiGetOrCreateUserRequestMarkAsUserType["UNSPECIFIED"] = "USER_TYPE_UNSPECIFIED";
})(StreemApiGetOrCreateUserRequestMarkAsUserType || (StreemApiGetOrCreateUserRequestMarkAsUserType = {}));
//# sourceMappingURL=StreemApiGetOrCreateUserRequest.js.map